import { render } from "./MyTeam.vue?vue&type=template&id=1c68b3bb&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"

import "./MyTeam.vue?vue&type=style&index=0&id=1c68b3bb&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c68b3bb"]])

export default __exports__